async function addCartAttribute(e) {
    const targetDay = 1;

    const currentDay = new Date().getDay();

    const cartData = await fetch("/cart.json").then((data) => data.json()).then((data2) => data2);
    const attributes = cartData.attributes;

    if (currentDay === targetDay) {
        fetch(window.Shopify.routes.root + `cart/update.js`, {
            method: "POST",
            "headers": {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "attributes": {
                    ...attributes,
                    MONDAYOFFER: true
                }
            })
        }).then(() => {
            window.location.href = "/checkout"
        })
    } else if (attributes.MONDAYOFFER) {
        fetch(window.Shopify.routes.root + `cart/update.js`, {
            method: "POST",
            "headers": {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "attributes": {
                    ...attributes,
                    MONDAYOFFER: null
                }
            })
        }).then(() => {
            window.location.href = "/checkout"
        })
    } else {
        window.location.href = "/checkout"
    }
}